import _classCallCheck from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/owner/Code/salesgear/salesgear-web/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @packageDocumentation
 * @module Tools
 * @internalapi
 */
import { InvalidArgumentError } from './errors';
/**
 * A Map of DTMF Sound Names to their mock frequency pairs.
 */

var bandFrequencies = {
  dtmf0: [1360, 960],
  dtmf1: [1230, 720],
  dtmf2: [1360, 720],
  dtmf3: [1480, 720],
  dtmf4: [1230, 790],
  dtmf5: [1360, 790],
  dtmf6: [1480, 790],
  dtmf7: [1230, 870],
  dtmf8: [1360, 870],
  dtmf9: [1480, 870],
  dtmfh: [1480, 960],
  dtmfs: [1230, 960]
};

var DialtonePlayer = /*#__PURE__*/function () {
  function DialtonePlayer(_context) {
    var _this = this;

    _classCallCheck(this, DialtonePlayer);

    this._context = _context;
    /**
     * Gain nodes, reducing the frequency.
     */

    this._gainNodes = [];
    this._gainNodes = [this._context.createGain(), this._context.createGain()];

    this._gainNodes.forEach(function (gainNode) {
      gainNode.connect(_this._context.destination);
      gainNode.gain.value = 0.1;

      _this._gainNodes.push(gainNode);
    });
  }

  _createClass(DialtonePlayer, [{
    key: "cleanup",
    value: function cleanup() {
      this._gainNodes.forEach(function (gainNode) {
        gainNode.disconnect();
      });
    }
    /**
     * Play the dual frequency tone for the passed DTMF name.
     * @param sound
     */

  }, {
    key: "play",
    value: function play(sound) {
      var _this2 = this;

      var frequencies = bandFrequencies[sound];

      if (!frequencies) {
        throw new InvalidArgumentError('Invalid DTMF sound name');
      }

      var oscillators = [this._context.createOscillator(), this._context.createOscillator()];
      oscillators.forEach(function (oscillator, i) {
        oscillator.type = 'sine';
        oscillator.frequency.value = frequencies[i];
        oscillator.connect(_this2._gainNodes[i]);
        oscillator.start();
        oscillator.stop(_this2._context.currentTime + 0.1);
        oscillator.addEventListener('ended', function () {
          return oscillator.disconnect();
        });
      });
    }
  }]);

  return DialtonePlayer;
}();

export { DialtonePlayer as default };